import {RouterView} from '../RouterView.js';
import Admin from '../../components/views/admin/Index';
import User from './User';
import Profile from './Profile';
import Office from './Office';
import Configuration from './Configuration';
import Statistic from './Statistic';
import Catalogs from "./Catalogs";

export default{
	path: "administracion",
	component: RouterView,
	children:[
		{
			path: '',
			component:Admin
		},
		{ ...User},
        { ...Profile},
        { ...Office},
        {...Configuration},
        {...Statistic},
        {...Catalogs},

	]
}
